import { Component } from "@angular/core";
import { SurveyService } from "./services/survey.service";
import { environment } from "../environments/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AppUpdateDialogComponent } from "./dialogs/app-update-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent {
  title = "app";
  showHeader: boolean = true;

  constructor(
    private surveyService: SurveyService,
    private _snackBar: MatSnackBar,
    public router: Router,
    public dialog: MatDialog,
  ) {
    
  }

  async ngOnInit() {
    let apiVersion = await this.surveyService.getApiVersion().toPromise();
       
    // var pjson = require("../../package.json");
    // console.log("package version: " + pjson.version);
    // let packageVs: string = pjson.version;
    // if (!environment.production) {
    //   packageVs = pjson.version + " - dev";
    // }
    if (apiVersion !== environment.appVersion) {
      this.openSnackBar(
        "A new version of this application is available",
        "Update"
      );
      //this.openAppUpdateDialog();
  
    }
    if (this.router.url.includes('exemption-request-submission')
      || this.router.url.includes('exemption-secondary-review-request')
      || this.router.url.includes('covid-return-to-work')
      || this.router.url.includes('covid-rtw-negative-test')
      || this.router.url.includes('return-to-work')
      || this.router.url.includes('spark-moment-survey')
      || this.router.url.includes('return-to-work-acknowledgement')
      || this.router.url.includes('verify/survey')    ) {
      this.showHeader = false;
    }

    console.log("app version: " + environment.appVersion + " & api version: " + apiVersion);
    console.log("Show Header: " + this.showHeader);
  }

  openSnackBar(message: string, action: string) {
    let snackBarRef = this._snackBar.open(message, action);

    snackBarRef.afterDismissed().subscribe(() => {
      location.reload();
    });

    snackBarRef.onAction().subscribe(() => {
      console.log("The snack-bar action was triggered!");
    });
  }

  // openAppUpdateDialog(){
  //   const dialogRef = this.dialog.open(AppUpdateDialogComponent, {
  //     width: "450px",
  //     disableClose: true
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     location.reload();
  //   });
  // }
}
